import { IOmniaCommand, IOmniaCommandGroup } from "../types"

export class OmniaCommandGroup implements IOmniaCommandGroup {


    private readonly _fg: IOmniaCommand[]
    private readonly _bg: IOmniaCommand[]

    constructor(
        public readonly text: string,
        public readonly datacontext: any,
        public readonly commands: IOmniaCommand[] = [],
        public readonly foreground: boolean = true
    ) {

        this._fg = (this.commands || []).filter((v) => v.foreground)

        const bg = (this.commands || []).filter((v) => !v.foreground)
        this._bg = bg && bg.length ? bg : undefined

    }

    foregroundCommands(): IOmniaCommand[] {
        return this._fg
    }

    backgroundCommands(): IOmniaCommand[] {
        return this._bg
    }

}
